export default __webpack_public_path__ + "static/media/selamat11.1cc6d1af.svg";